import { Component, OnInit, ElementRef } from '@angular/core';

@Component({
  selector: 'app-what',
  templateUrl: './what.component.html',
  styleUrls: ['./what.component.scss']
})
export class WhatComponent {

}

//   <ol>
//     <li>
//         <b>What is heroin?</b>
//         <ul>
//             <li>
//                 Heroin is an opioid drug made from morphine, a natural substance taken from the seed pod of opium poppy plants. 
//                 Heroin can be a white or brown powder, or a black sticky substance known as black tar heroin. Heroin can be sniffed, snorted, smoked or injected.
//             </li>
//             <li>
//                 Heroin enters the brain rapidly and binds to opioid receptors on cells located in many areas, especially those involved in feelings of pain and 
//                 pleasure and in controlling heart rate, sleeping, and breathing.
//             </li>
//             <li>
//                 People who use heroin report feeling a "rush" (a surge of pleasure, or euphoria). However, there are other common effects, including:
//                 <ul>
//                     <li>dry mouth</li>
//                     <li> warm flushing of the skin</li>
//                     <li> heavy feeling in the arms and legs</li>
//                     <li> nausea and vomiting</li>
//                     <li> severe itching</li>
//                     <li> clouded mental functioning</li>
//                     <li> going "on the nod," a back-and-forth state of being conscious and semiconscious</li>
//                 </ul>
//             </li>
//             <li>
//                 People who use heroin over the long term may develop:
//                 <ul>
//                     <li> insomnia </li>
//                     <li> collapsed veins for people who inject the drug </li>
//                     <li> damaged tissue inside the nose for people who sniff or snort it </li>
//                     <li> infection of the heart lining and valves </li>
//                     <li> abscesses (swollen tissue filled with pus) </li>
//                     <li> constipation and stomach cramping </li>
//                     <li> liver and kidney disease </li>
//                     <li> lung complications, including pneumonia </li>
//                     <li> mental disorders such as depression and antisocial personality disorder </li>
//                     <li> sexual dysfunction for men </li>
//                     <li> irregular menstrual cycles for women </li>
//                 </ul>
//             </li>
//         </ul>
//     </li>
//     <li>
//         <b>What is heroin addiction?</b>
//         <ul>
//             <li>
//                 Heroin is highly addictive. People who regularly use heroin often develop a tolerance, which means that they need higher 
//                 and/or more frequent doses of the drug to get the desired effects.
//             </li>
//             <li>
//                 Heroin addiction occurs when continued use of the drug causes issues, such as health problems and failure to meet 
//                 responsibilities at work, school, or home. Heroin addiction can range from mild to severe, the most severe form being addiction.
//             </li>
//             <li>
//                 Those who are addicted to heroin and stop using the drug abruptly may have severe withdrawal. Withdrawal symptoms— 
//                 which can begin as early as a few hours after the drug was last taken—include:
//                 <ul>
//                     <li>restlessness</li>
//                     <li>severe muscle and bone pain</li>
//                     <li>sleep problems</li>
//                     <li>diarrhoea and vomiting</li>
//                     <li>cold flashes with goose bumps ("cold turkey")</li>
//                     <li>uncontrollable leg movements ("kicking the habit")</li>
//                     <li>severe heroin cravings</li>
//                 </ul>
//             </li>
//             <li>
//                 Recognising heroin addiction is key to getting help, for yourself or a family member. If you use heroin, a common addiction test 
//                 would be to assess your usage using free, online assessment tools. If you suspect a loved one 
//                 or family member of heroin addiction, recognising the following signs could provide some clues:
//                 <ul>
//                     <li> Constricted (tiny) pupils </li>
//                     <li> Breathing difficulties </li>
//                     <li> Unnecessary outbursts and irritability </li>
//                     <li> Cycles of hyperactivity followed by suddenly sleeping </li>
//                     <li> Droopy appearance, as if their limbs are heavy </li>
//                 </ul>
//             </li>
//             <li>
//                     A range of treatments including medicines and behavioural therapies are effective in helping people stop heroin use. 
//                     It’s important to match the best treatment approach to meet the particular needs of each 
//                     individual patient. Please see here if you would like to read about treatment options for heroin addiction.
//             </li>
//         </ul>
//     </li>
// </ol>
